module.exports = "<style>div .google-visualization-tooltip>ul>li>span{white-space:nowrap}</style> <div flex layout=row layout-align=\"start center\" layout-wrap style=overflow-x:auto> <div class=md-whiteframe-3dp flex id=singlechart flex style=margin:8px;height:98%></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/single_chart/views/single_chart.html
// module id = 1415
// module chunks = 453